module.exports = __webpack_public_path__ + "img/portrait-038.be4d32ba.jpg";